import React from 'react'
import { ListItemText, ListItemTextProps } from '@material-ui/core'
import { TOptions } from 'i18next'
import { useTranslation } from 'react-i18next'

type Props = {
  primaryTranslationKey: string
  /**
   * defaults to translationKeyPrimaryText_subtitle
   */
  secondaryTranslationKey?: string
  primary?: string
  secondary?: string
  options?: TOptions
  ns?: string[]
} & ListItemTextProps

export const LocalizedListItemText = (props: Props) => {
  const {
    primaryTranslationKey,
    secondaryTranslationKey = props.primaryTranslationKey + '_subtitle',
    primary: primaryDefaultValue,
    secondary: secondaryDefaultValue,
    options,
    ns,
    ...listItemProps
  } = props

  const { t } = useTranslation(
    ...[
      primaryTranslationKey.indexOf(':') > 0
        ? primaryTranslationKey.split(':')[0]
        : [],
      secondaryTranslationKey.indexOf(':') > 0
        ? secondaryTranslationKey.split(':')[0]
        : [],
      ...(ns ?? []),
    ]
  )

  return (
    <ListItemText
      {...listItemProps}
      primary={t(primaryTranslationKey, options ?? primaryDefaultValue)}
      secondary={t(secondaryTranslationKey, options ?? secondaryDefaultValue)}
    />
  )
}
